export enum SwapStep {
  COUNTERPARTY,
  DESIRED,
  OFFERED,
  REVIEW,
  CREATED,
}
